import { computed, ref, watch, onMounted, onUnmounted } from 'vue';
import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fa5277f2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "player_container"
};
const _hoisted_2 = {
  class: "player"
};
const _hoisted_3 = {
  class: "headerImg"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
import flvjs from '@/utils/flvDemuxer/flv.js';
import LottieView from '@/components/lottieView.vue';
import lottieJson from '../../../../public/animationData/loading/avatar.json';
// import flvjs from 'flv.js'
import bus from '@/utils/mitt.js';
import { digitalHeartBeat } from '@/utils/data.js';
import roleHooks from '@/hooks/roleV2Hooks';
import { useRoute } from 'vue-router';
import { isMobile } from '@/utils/index';
import env from '@/env';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['connectError'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const route = useRoute();
    const {
      curSelectRoleInfo,
      curDigitalInfo
    } = roleHooks();
    const videoUrl = computed(() => {
      return curDigitalInfo.value.figureUrl;
    });
    const mvideo = ref();
    watch(curSelectRoleInfo, () => {
      mvideo.value.play();
      setTimeout(() => {
        showHeaderImg.value = false;
      }, 1000);
    });
    //抠图
    const video = ref(null);
    const c2 = ref(null);
    const player = ref(null);
    let websocket = null;
    let wsStaus = ref(false);
    let isFlving = ref(false);
    let showHeaderImg = ref(false);
    const webglCut = window.webglCut;
    // 校验环境
    const checkCondition = () => {
      if ('WebSocket' in window) {
        if (flvjs.isSupported()) {
          startPlayer();
        } else {
          ElMessage.error('当前浏览器不支持flv播放');
        }
      } else {
        ElMessage.error('当前浏览器不支持websocket连接');
      }
    };
    const startPlayer = () => {
      let isInit = false;
      player.value = flvjs.createPlayer({
        type: 'flv',
        url: env.AVATARURL,
        // url: 'wss://streaming-neural-avatar.mobvoi.com/websocket/avatar',
        // url: 'ws://101.35.238.186:9041/websocket/avatar', //单台调试
        isLive: true,
        hasAudio: true,
        hasVideo: true,
        cors: true,
        duration: 30000
      }, {
        isLive: true,
        enableWorker: false,
        enableStashBuffer: false,
        stashInitialSize: 20,
        // 新增参数
        autoCleanupSourceBuffer: true,
        autoCleanupMaxBackwardDuration: 60,
        cbOpen: function (res) {
          bus.emit('flvEnd', true);
          console.log('建立websocket-avatar', res);
          websocket = res;
          wsStaus.value = false;
          // webglCut.load(video.value, c2.value, () => {
          //   video.value.addEventListener(
          //     'play',
          //     function () {
          //       webglCut.startWebcam(props.screenWidth, props.screenHeight)
          //     },
          //     false
          //   )
          // })
        },

        cbMessage: function (res, e, cb) {
          if (typeof e.data == 'object') {
            // clearTimeout(timer)
            //  timer = setTimeout(()=>{
            //   cb(true)
            //   }, 1000)
            isFlving.value = true;
            if (isInit) {
              player.value.flush(e.data);
              isInit = false;
            } else {
              cb();
            }
          } else if (e.data == 'ppg-end') {
            console.log('ppg-end');
            // wsStaus.value = false
          } else if (e.data == 'requests overload') {
            emits('connectError', 'overload');
            console.error('requests overload', e.data);
            wsStaus.value = false;
          } else {
            const obj = JSON.parse(e.data);
            if (obj.type == 'server_ready') {
              var _digitalHeart;
              console.log('可以发送语音文件');
              wsStaus.value = true;
              player.value.attachMediaElement(video.value);
              digitalHeart = digitalHeartBeat(res);
              (_digitalHeart = digitalHeart) === null || _digitalHeart === void 0 ? void 0 : _digitalHeart.setStatus(false);
            } else if (obj.type == 'server_paused') {
              console.log('server_paused');
            } else if (obj.type == 'server_ended') {
              var _digitalHeart2;
              isInit = true;
              console.log('server_ended');
              wsStaus.value = false;
              (_digitalHeart2 = digitalHeart) === null || _digitalHeart2 === void 0 ? void 0 : _digitalHeart2.close();
              player.value.pushEof();
            } else if (obj.type == 'server_canceled') {
              console.log('server_canceled');
            } else if (obj.type == 'server_exit') {
              emits('connectError', 'exit');
              console.log('server_exit');
            }
          }
        },
        cbError: function (res, e) {
          emits('connectError', e);
          console.error('websocket-avatar错误：', e);
          wsStaus.value = false;
        },
        cbClose: function (res, e) {
          // debugger
          if (res.code != 1000) {
            emits('connectError', 'close');
          }
          console.log('websocket-avatar关闭：', e);
          wsStaus.value = false;
        }
      });
      player.value.attachMediaElement(video.value);
      player.value.load();
      let decodedFrames;
      let timer;
      player.value.on('statistics_info', e => {
        if (e.decodedFrames != 0 && e.decodedFrames == decodedFrames) {
          timer = setTimeout(() => {
            if (e.decodedFrames == decodedFrames && !isSendFlvend.value) {
              console.log(e.decodedFrames, '---decodedFrames---');
              isSendFlvend.value = true;
              isFlving.value = false;
              bus.emit('flvEnd', true);
            } else {
              clearTimeout(timer);
            }
          }, 2000);
          return;
        }
        if (e.decodedFrames == 0) isSendFlvend.value = false;
        decodedFrames = e.decodedFrames;
      });
      player.value.on('loading_complete', e => {
        console.error('player loading_complete', e);
      });
      player.value.on('recovered_early_eof', e => {
        console.error('player recovered_early_eof', e);
      });
      player.value.on('error', e => {
        console.error('player error', e);
      });
    };
    const videoProgress = () => {
      // let end = player.value.buffered.end(0) //获取当前buffered值(缓冲区末尾)
      // let delta = end - player.value.currentTime //获取buffered与当前播放位置的差值
      // console.log(end, player.value.currentTime, '---videoProgress---')
    };
    const isSendFlvend = ref(false);
    const videoEnd = () => {
      console.log('flv播放结束');
      isFlving.value = false;
      isSendFlvend.value = true;
      bus.emit('flvEnd', true);
    };
    const destroyFlv = () => {
      console.log(123, 'destroyFlv');
      websocket && websocket.close();
      if (player.value) {
        player.value.pause();
        player.value.unload();
        player.value.detachMediaElement();
        player.value.destroy();
        player.value = null;
      }
    };
    // 启动 ws 指令
    const sendStart = ws => {
      console.log('ws.send start !');
      const signal = JSON.stringify({
        signal: 'start',
        input_format: 'audio/x-wav;codec=pcm;bit=16;rate=16000',
        output_format: 'flv',
        msg_id: '123',
        source: 'test',
        speaker: curDigitalInfo.value.speakerId
        // speaker: 'yuanruoxi_6_400'
      });

      ws === null || ws === void 0 ? void 0 : ws.send(signal);
    };
    const sendPause = ws => {
      console.log('ws.send pause !');
      const signal = JSON.stringify({
        signal: 'pause'
      });
      ws === null || ws === void 0 ? void 0 : ws.send(signal);
    };
    const sendQuietAudio = ws => {
      const u8arr = new Uint8Array(16 * 3000);
      console.log('ws.send quietAudio !');
      ws === null || ws === void 0 ? void 0 : ws.send(u8arr);
    };
    const sendEnd = ws => {
      console.log('ws.send end !');
      const signal = JSON.stringify({
        signal: 'end'
      });
      ws === null || ws === void 0 ? void 0 : ws.send(signal);
    };
    onMounted(() => {
      checkCondition();
      window.addEventListener('beforeunload', function (event) {
        destroyFlv();
      });
      window.addEventListener('onunload', function (event) {
        destroyFlv();
      });
      bus.on('initPlayer', () => {
        // mvideo.value.play()
        // video.value.play()
        setTimeout(() => {
          showHeaderImg.value = false;
        }, 1000);
      });
      if (isMobile()) {
        showHeaderImg.value = true;
      }
    });
    onUnmounted(() => {
      // webglCut.endWebcam()
      destroyFlv();
    });
    bus.on('reConnect', () => {
      destroyFlv();
      startPlayer();
    });
    bus.on('sendStatus', status => {
      if (status == 'start') {
        sendStart(websocket);
      } else {
        let timer = setInterval(() => {
          var _digitalHeart3;
          if (((_digitalHeart3 = digitalHeart) === null || _digitalHeart3 === void 0 ? void 0 : _digitalHeart3.getBlobList()) == 0) {
            var _digitalHeart4;
            clearInterval(timer);
            (_digitalHeart4 = digitalHeart) === null || _digitalHeart4 === void 0 ? void 0 : _digitalHeart4.setStatus(true);
            // sendQuietAudio(websocket)
            sendEnd(websocket);
          }
        }, 40);
      }
    });
    // audio数据传入
    let digitalHeart = null;
    const audioBlob = blob => {
      if (websocket && wsStaus.value) {
        if (blob instanceof Array) {
          var _digitalHeart5;
          (_digitalHeart5 = digitalHeart) === null || _digitalHeart5 === void 0 ? void 0 : _digitalHeart5.inputBlod(blob);
        } else {
          var _digitalHeart6;
          (_digitalHeart6 = digitalHeart) === null || _digitalHeart6 === void 0 ? void 0 : _digitalHeart6.inputBlod([blob]);
        }
      }
    };
    expose({
      audioBlob
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(LottieView, {
        class: "lottie",
        autoplay: true,
        loop: true,
        jsonData: _unref(lottieJson),
        assetsPath: "/animationData/loading/images/"
      }, null, 8, ["jsonData"]), _withDirectives(_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        src: _unref(curSelectRoleInfo).gifUrl,
        alt: ""
      }, null, 8, _hoisted_4)], 512), [[_vShow, _unref(showHeaderImg)]]), _createElementVNode("video", {
        ref_key: "mvideo",
        ref: mvideo,
        src: _unref(videoUrl),
        muted: "",
        loop: "",
        autoplay: ""
      }, null, 8, _hoisted_5), _createElementVNode("video", {
        class: _normalizeClass(["flv_video", {
          flv_vide_show: _unref(isFlving)
        }]),
        onEnded: videoEnd,
        onProgress: videoProgress,
        ref_key: "video",
        ref: video,
        autoplay: ""
      }, null, 34)])]);
    };
  }
});